// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 69,
  argument: "A prayer in persecution.",
  verses: [
    { n: 1, text: "Unto the end, a psalm for David, to bring to remembrance that the Lord saved him." },
    { n: 2, text: "O God, come to my assistance; O Lord, make haste to help me." },
    { n: 3, text: "Let them be confounded and ashamed that seek my soul:" },
    { n: 4, text: "Let them be turned backward, and blush for shame that desire evils to me: Let them be presently turned away, blushing for shame, that say to me: 'Tis well, 'tis well." },
    { n: 5, text: "Let all that seek thee rejoice and be glad in thee; and let such as love thy salvation, say always: The Lord be magnified." },
    { n: 6, text: "But I am needy and poor; O God, help me. Thou art my helper and my deliverer: O Lord, make no delay." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Remembrance. This is all that occurs in Hebrew, or in many Greek copies, though the following words were perhaps extant in the copy of the Septuagint, or were added to complete the sentence. Several of the verses are found in Psalm xxxiv., and xxxix., and seem to have been used as a form of prayer in any danger. (Berthier) — David foresaw that Christ would pray for the safety of his natural and mystical body, and would be heard. (Menochius) — The following psalm is a sequel to this.", attribution: "Calmet" }
    ] },
    { verse: 4, notes: [
      { text: "'Tis well, 'tis well. Euge, euge. St. Jerome renders it, vah! vah! which is the voice of one insulting and deriding. Some understand it as a detestation of deceitful flatterers. (Challoner) — In the New Testament, Well done, denotes applause. (St. Jerome in Ezechiel vi.) — These predictions relate to the murderers of the Messias. (Berthier) — In the 39th psalm, the Church prays for aid; and here David, persecuted by Absalom, or any of the just, lays before God his particular wants.", attribution: "Worthington" }
    ] },
  ],
};

export default chapter;
